export enum TfbOfficeUsers {
	CYPRUS = 'cyprus',
	GEORGIA = 'georgia',
	RUSSIA = 'russia',
	SINGAPORE = 'singapore',
	UAE = 'uae',
	UK = 'uk'
}
